export default __webpack_public_path__ + "static/media/blog-2a.2fd3a123.jpg";